import LotsService from "@/modules/lots/LotsService";
import IncrementsService from "@/modules/sales/view/increments/IncrementsService";
import SalesService from "@/modules/sales/SalesService";

export default {
  namespaced: true,
  state: {
    loading: false,
    extraFilters: {},
    extraExpands: '',
    view: {
      loading: false,
      currentReservation: null,
      images: [],
      settings: {
        loading: false
      },
      incrementsData: {
        increments: [],
        modal: {
          show: false
        }
      },
      lotIncrementsData: {
        increments: [],
        modal: {
          show: false,
          sale: null,
          increments: null,
          lot: null
        }
      },
      termsData: {
        premiums: [],
        minimum_premium: null,
        payment_terms: [],
        settlement_days: [],
        paymentTermsModal: {
          show: false
        },
        settlementDaysModal: {
          show: false
        },
        financialItemChargeModal: {
          show: false,
          object: null
        },
        taxStatusModal: {
          show: false,
          object: null
        },
        taxRateModal: {
          show: false,
          object: null
        },
        premiumsModal: {
          show: false
        },
        financialItemPremiumsModal: {
          show: false,
          object: null,
          reservation: null,
          source: null
        },
        commissionsModal: {
          show: false,
          object: null,
          reservation: null,
          source: null
        },
      }
    }
  },
  getters: {
    disableActions: state => {
      if (state.view.currentReservation && state.view.currentReservation.inventory) {
        return state.view.currentReservation.inventory.is_archived || ['withdrawn'].includes(state.view.currentReservation.status)
      }
      return false
    }
  },
  actions: {
    async getReservation({commit, state}, uuid) {
      commit('updateTableLoading', true);
      const expands = state.extraExpands;
      let hardExpands = [
        'inventory.source_inventories_count',
        'inventory.grouped_inventories_count',
        'inventory.receipt',
        'inventory.images',
        'inventory.category',
        'inventory.department',
        'inventory.item_location',
        'inventory.customer.billing_address',
        'inventory.branch',
        'inventory.specialists',
        'lot.financial_item.financial_item_charges.charge',
        'lot.increments',
        'inventory.customer.shipping_address',
        'auction',
        'auction.currency',
        'auction.dates',
        'auction.department',
        'auction.increments',
        'customer.logo',
        'previous_uuid',
        'next_uuid'
      ]
      let response = await LotsService.getReservation(uuid, `${hardExpands.join(',')},${expands}`);
      commit('updateTableLoading', false);
      if (response.success) {
        commit('updateViewReservation', response.body);
      }
      return response;
    },
    async getReservationByLotNo({commit, state}, {lotNo, auctionUuid}) {
      commit('updateTableLoading', true);
      const expands = state.extraExpands;
      let data = {exact_lot_no: lotNo};
      if (auctionUuid) {
        data['auction_uuid'] = auctionUuid;
      }
      let response = await LotsService.getReservationByLotNo(`inventory.receipt,inventory.specialists,lot.financial_item.settlement,inventory.images,inventory.category,inventory.department,inventory.item_location,inventory.customer.billing_address,inventory.branch,lot,lot.financial_item,inventory.customer.shipping_address,customer.logo,auction,auction.currency,auction.dates,auction.department,${expands}`, data);
      commit('updateTableLoading', false);
      if (response.success && response.body.results.length > 0) {
        commit('updateViewReservation', response.body.results[0]);
      }
      return response;
    },
    async updateViewReservation({commit}, data) {
      commit('updateViewReservation', data);
    },
    async getIncrements({commit, state}) {
      commit('updateSettingsLoading', true);
      let response = await IncrementsService.getIncrements(state.view.currentReservation.auction_uuid);
      commit('updateSettingsLoading', false);
      if (response.success) {
        commit('updateIncrements', response.body);
      }
      return response;
    },
    async postIncrements({commit, state}, payload) {
      let response = await IncrementsService.postIncrements(state.view.currentReservation.auction_uuid, payload);
      if (response.success) {
        commit('updateIncrements', response.body);
      }
      return response;
    },
    async getTermsData({commit, state}) {
      commit('updateSettingsLoading', true);
      let response = await SalesService.getSale(state.view.currentReservation.auction_uuid, 'premiums');
      commit('updateSettingsLoading', false);
      if (response.success) {
        let {premiums} = response.body;
        await commit('updateTermsData', {
          premiums,
          minimum_premium: response.body.minimum_premium,
          payment_terms: response.body.payment_terms,
          settlement_days: response.body.settlement_days,
        });
      }
      return response
    },
    updateSale({commit, state}, payload) {
      commit('updateSale', payload);
    },
    updateReservation({commit}, payload) {
      commit('updateReservation', payload);
    },
    updateVendor({commit}, payload) {
      commit('updateVendor', payload);
    },
    async togglePaymentTermsModal({commit}, payload) {
      commit('togglePaymentTermsModal', payload);
    },
    async toggleSettlementDaysModal({commit}, payload) {
      commit('toggleSettlementDaysModal', payload);
    },
    async togglePremiumsModal({commit}, payload) {
      commit('togglePremiumsModal', payload);
    },
    async saveTermsPartialData({commit, state}, payload) {
      let response = await SalesService.partialUpdateSale(state.view.currentReservation.auction_uuid, payload);
      if (response.success) {
        commit('updateTermsData', payload);
      }
      return response;
    },
    async toggleIncrementsModal({commit, state}, payload) {
      commit('toggleIncrementsModal', payload);
    },
    async showLotIncrementsModal({commit}, payload) {
      commit('showLotIncrementsModal', payload);
    },
    async hideLotIncrementsModal({commit}) {
      commit('hideLotIncrementsModal');
    },
    async postLotIncrements({commit, state}, payload) {
      let response = await IncrementsService.postLotIncrements(state.view.currentReservation.lot.uuid, payload);
      if (response.success) {
        commit('updateLotIncrements', response.body);
      }
      return response;
    },
    async showCommissionsModal({commit}, payload) {
      commit('showCommissionsModal', payload)
    },
    async showFinancialItemPremiumsModal({commit}, payload) {
      commit('showFinancialItemPremiumsModal', payload)
    },
    async hideCommissionsModal({commit}) {
      commit('hideCommissionsModal')
    },
    async hideFinancialItemPremiumsModal({commit}) {
      commit('hideFinancialItemPremiumsModal')
    },
    async updateLotTerms({commit}, payload) {
      return await LotsService.updateLotTerms(payload);
    },
    async updateLotTaxStatus({state}, payload) {
      let response = await LotsService.updateLotTerms(payload);
      if (response.success) {
        state.view.currentReservation.lot.financial_item.tax_status_uuid = payload.data.tax_status_uuid
      }
      return response
    },
    async updateLotTaxRate({state}, payload) {
      let response = await LotsService.updateLotTerms(payload);
      if (response.success) {
        state.view.currentReservation.lot.financial_item.tax_rate = payload.data.tax_rate
      }
      return response
    },
    async showFinancialItemChargeModal({commit}, payload) {
      commit('showFinancialItemChargeModal', payload);
    },
    async hideFinancialItemChargeModal({commit}, payload) {
      commit('hideFinancialItemChargeModal', payload);
    },
    async saveFinancialItemCharge({state}, payload) {
      let response = await LotsService.updateFinancialItemCharge(payload.uuid, payload)
      if (response.success && state.view.currentReservation.lot) {
        let fic = state.view.currentReservation.lot.financial_item.financial_item_charges.find(fic => fic.uuid === payload.uuid)
        if (fic) {
          fic.amount = response.body.amount
          fic.vat = response.body.vat
        }
      }
      return response
    },
    async showTaxStatusModal({commit}, payload) {
      commit('showTaxStatusModal', payload);
    },
    async showTaxRateModal({commit}, payload) {
      commit('showTaxRateModal', payload);
    },
    async hideTaxStatusModal({commit}, payload) {
      commit('hideTaxStatusModal', payload);
    },
    async hideTaxRateModal({commit}, payload) {
      commit('hideTaxRateModal', payload);
    },
  },
  mutations: {
    updateViewReservation: (state, reservation) => state.view.currentReservation = reservation,
    updateTableLoading: (state, loading) => state.view.loading = loading,
    updateSettingsLoading: (state, loading) => state.view.settings.loading = loading,
    updateIncrements: (state, increments) => state.view.incrementsData.increments = increments,
    updateLotIncrements: (state, increments) => {
      state.view.lotIncrementsData.increments = increments;
      state.view.currentReservation.lot.increments = increments;
    },
    updateTermsData: (state, data) => state.view.termsData = {...state.view.termsData, ...data},
    updateSale: (state, sale) => _.merge(state.view.currentReservation.auction, sale),
    updateReservation: (state, reservation) => _.merge(state.view.currentReservation, reservation),
    updateVendor: (state, vendor) => _.merge(state.view.currentReservation.inventory.customer, vendor),
    togglePaymentTermsModal: (state, show) => state.view.termsData.paymentTermsModal.show = show,
    toggleSettlementDaysModal: (state, show) => state.view.termsData.settlementDaysModal.show = show,
    togglePremiumsModal: (state, show) => state.view.termsData.premiumsModal.show = show,
    toggleIncrementsModal: (state, show) => state.view.incrementsData.modal.show = show,
    showLotIncrementsModal: (state, {show, sale, lot, increments}) => {
      state.view.lotIncrementsData.modal.show = show;
      state.view.lotIncrementsData.modal.sale = sale;
      state.view.lotIncrementsData.modal.increments = increments;
      state.view.lotIncrementsData.modal.lot = lot;
    },
    hideLotIncrementsModal: (state) => {
      state.view.lotIncrementsData.modal.show = false;
      state.view.lotIncrementsData.modal.sale = null;
      state.view.lotIncrementsData.modal.lot = null;
    },
    showCommissionsModal: (state, {source, object, reservation}) => {
      state.view.termsData.commissionsModal.show = true
      state.view.termsData.commissionsModal.source = source
      state.view.termsData.commissionsModal.object = object
      state.view.termsData.commissionsModal.reservation = reservation
    },
    showFinancialItemPremiumsModal: (state, {source, object, reservation}) => {
      state.view.termsData.financialItemPremiumsModal.show = true
      state.view.termsData.financialItemPremiumsModal.source = source
      state.view.termsData.financialItemPremiumsModal.object = object
      state.view.termsData.financialItemPremiumsModal.reservation = reservation
    },
    hideCommissionsModal: (state) => {
      state.view.termsData.commissionsModal.show = false
      state.view.termsData.commissionsModal.source = null
      state.view.termsData.commissionsModal.object = null
      state.view.termsData.commissionsModal.reservation = null
    },
    hideFinancialItemPremiumsModal: (state) => {
      state.view.termsData.financialItemPremiumsModal.show = false
      state.view.termsData.financialItemPremiumsModal.source = null
      state.view.termsData.financialItemPremiumsModal.object = null
      state.view.termsData.financialItemPremiumsModal.reservation = null
    },
    showFinancialItemChargeModal: (state, {object, source}) => {
      state.view.termsData.financialItemChargeModal.show = true
      state.view.termsData.financialItemChargeModal.source = source
      state.view.termsData.financialItemChargeModal.object = object
    },
    hideFinancialItemChargeModal: (state) => {
      state.view.termsData.financialItemChargeModal.show = false
      state.view.termsData.financialItemChargeModal.source = null
      state.view.termsData.financialItemChargeModal.object = null
    },
    showTaxStatusModal: (state, data) => {
      state.view.termsData.taxStatusModal.show = true
      state.view.termsData.taxStatusModal.object = data.object
    },
    showTaxRateModal: (state, data) => {
      state.view.termsData.taxRateModal.show = true
      state.view.termsData.taxRateModal.object = data.object
    },
    hideTaxStatusModal: (state) => {
      state.view.termsData.taxStatusModal.show = false
      state.view.termsData.taxStatusModal.object = null
    },
    hideTaxRateModal: (state) => {
      state.view.termsData.taxRateModal.show = false
      state.view.termsData.taxRateModal.object = null
    },
  }
}
